import React, { FC, ReactNode } from "react";
import { Icon, Preview } from "@evergis/ui";

import { ImageAttribute } from "./ImageAttribute";
import { AttributeLabel } from "../../styled";
import { ImageAttributesContainer, ButtonContainer } from "./styled";
import { useAddImageAttribute } from "../../../../hooks/useDialogs";
import { useImageAttributeSrc } from "../../hooks/useImageAttributeSrc";

type ImageAttributesProps = {
  name: string;
  label: ReactNode;
  value?: string;
  isEdit?: boolean;
};

export const ImageAttributes: FC<ImageAttributesProps> = ({ value, name, label, isEdit }) => {
  const openDialog = useAddImageAttribute();
  const { urls, isOpenPreview, previewImages, deleteImageAttribute, expandImage, closePreview } = useImageAttributeSrc(
    name,
    value,
  );

  return (
    <>
      <AttributeLabel isEdit={isEdit}>{label}</AttributeLabel>
      <ImageAttributesContainer>
        {urls &&
          urls.length &&
          urls.map(url => (
            <ImageAttribute
              key={url}
              src={url}
              isEdit={isEdit}
              onDelete={deleteImageAttribute}
              onExpand={expandImage}
            />
          ))}

        {isEdit && (
          <ButtonContainer onClick={() => openDialog(null, { name })}>
            <Icon kind={"feature_add"} />
          </ButtonContainer>
        )}
      </ImageAttributesContainer>

      <Preview images={previewImages} isOpen={isOpenPreview} onClose={closePreview} />
    </>
  );
};
